module.exports = __webpack_public_path__ + "static/media/gpay.17708cb2.png";